<template>
  <div :class="[bem(), className]">
    <a
      v-for="item in list"
      :key="item.id"
      v-track="[
        {
          act: 'show',
          params: {
            cfrom: '093|002|02|077',
            event_id: '093|002|02|077',
            sku_id: item.id
          }
        },
        {
          act: 'click',
          params: {
            cfrom: '093|002|01|077',
            event_id: '093|002|01|077',
            sku_id: item.id
          }
        }
      ]"
      :href="item.url"
      class="recommend-item"
    >
      <img class="tab-img" v-lazy="item.tagUrl" alt="" v-if="item.tagUrl" />
      <img class="item-img" v-lazy="item.imgUrl" alt="" v-if="item.imgUrl" />
      <div class="name">{{ item.name }}</div>
      <div class="desc" v-if="item.brief">{{ item.brief }}</div>
      <div class="price">
        <span class="yen">¥</span>
        <span>{{ item.salePrice | formatNumber }}</span>
        <span class="market" v-if="item.salePrice !== item.marketPrice">¥{{ item.marketPrice | formatNumber }}</span>
      </div>
    </a>
  </div>
</template>

<script>
import create from '../create'
import fetch from '@/api/fetch'

export default create({
  props: {
    className: [String, Object, Array],
    orderNo: [String, Number],
    orderStatus: [String, Number]
  },
  name: 'recommend',
  data() {
    return {
      list: []
    }
  },
  async created() {
    const data = await fetch({
      url: '/recommend/list',
      method: 'post'
    })
    if (data && data.length) {
      this.list = data
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
